import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-28" data-mp="1l9o8reb6y9od">
      <div className="mx-auto max-w-3xl px-6" data-id="element-29" data-mp="1geimufhsgv0a">
        <h2 id="faq-title" className="text-center text-3xl font-extrabold tracking-tight text-navy-deep sm:text-4xl" data-id="element-30" data-mp="2e0zilgavj0jx">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 divide-y divide-slate-200 overflow-hidden rounded-2xl border border-slate-200" data-id="element-31" data-mp="241qqyu3hdy0q">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-32" data-mp="so6409l09dux" data-mpi={index}>
                <h3 data-id="element-33" data-mp="sl0guzvxsm1u">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 bg-white px-6 py-5 text-left transition-colors hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-navy/40" data-id="element-34" data-mp="no0ccteqjrcu">
                    <span className="text-base font-bold text-navy-deep" data-id="element-35" data-mp="kh0a6hxopxg9">{faq.question}</span>
                    <motion.span animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.2
                }} className="shrink-0 text-navy" aria-hidden="true" data-id="element-36" data-mp="6pve1ptiznao">
                      <ChevronDownIcon className="h-5 w-5" data-id="element-37" data-mp="1rk8hra9jyy9" />
                    </motion.span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-38" data-mp="3jyrssq3kwwe9">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-39" data-mp="3nya5iyl8y160">
                      <p className="px-6 pb-6 leading-relaxed text-ink/75" data-id="element-40" data-mp="1ftjc9xs0cxs1">{faq.answer}</p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}